import { useTranslation } from 'react-i18next';
import DashboardLineChart from './DashboardLineChart.js';
import { CHART_DUE_COLOR, CHART_NEUTRAL_COLOR, CHART_PAID_COLOR } from './chartTheme.js';

const CommissionTrendChart = ({ chartTrend, title }) => {
  const { t } = useTranslation();

  return (
    <DashboardLineChart
      t={t}
      title={title || t('dashboard.commissionPaidVsUnpaid')}
      chartTrend={chartTrend}
      emptyLabel={t('common.noData')}
      lines={[
        { dataKey: 'paid', name: t('dashboard.paidAmount'), color: CHART_PAID_COLOR },
        { dataKey: 'unpaid', name: t('dashboard.unpaidAmount'), color: CHART_DUE_COLOR },
        { dataKey: 'returned_commission', name: t('dashboard.returnedCommission', { defaultValue: 'Returned Commission' }), color: CHART_NEUTRAL_COLOR },
        { dataKey: 'missing_commission', name: t('dashboard.missingCommission', { defaultValue: 'Missing Commission' }), color: '#0f766e' },
      ]}
    />
  );
};

export default CommissionTrendChart;
